/* eslint-disable */
import { withStyles, withWidth } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import React from 'react';
import compose from 'recompose/compose';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import Terms from '../Terms/Terms.component';
import TermsAndConditionsLinkPropTypes from './TermsAndConditionsLink.component.props';
import termsAndConditionsLinkStyles from './TermsAndConditionsLink.component.styles';
import { isWidthDown } from '@material-ui/core/withWidth';
import cn from 'classnames'

/**
 * TermsAndConditionsLinkComponent
 * @export
 * @class TermsAndConditionsLinkComponent
 * @extends {React.Component<TermsAndConditionsLinkComponentComposedProps, TermsAndConditionsLinkComponentState>}
 */
export class TermsAndConditionsLinkComponent extends React.Component {
  state = {
    showTermsAndConditions: false,
  };

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OktaSignInWidgetComponent
   */
  static propTypes = TermsAndConditionsLinkPropTypes;

  handleClickOpen = () => {
    this.setState({ showTermsAndConditions: true });
  };

  handleClose = () => {
    this.setState({ showTermsAndConditions: false });
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered component
   * @memberof TermsAndConditionsLinkComponent
   */
  render() {
    const { showTermsAndConditions } = this.state;
    const { classes, fullScreen, width } = this.props;
    const isSmall = isWidthDown(`sm`, width);
    return (
      <React.Fragment>
        <div className={cn(classes.wrapper, isSmall && classes.wrapperSm)}>
          <span className={classes.termsAndConditions}>
            By signing in to Boral Connects you agree to the{` `}
            <a style={{ textDecoration: `underline`, cursor: 'pointer' }} onClick={this.handleClickOpen}>
              Terms and conditions
            </a>
          </span>
        </div>
        <Dialog aria-labelledby="responsive-dialog-title" fullScreen={fullScreen} onClose={this.handleClose} open={showTermsAndConditions}>
          <DialogContent>
            <Terms />
          </DialogContent>
          <DialogActions>
            <Button autoFocus color="primary" fullWidth onClick={this.handleClose} variant="contained">
              <I18n>LoginPage.TermsAndConditions.Read</I18n>
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

const TermsAndConditionsLink = compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(termsAndConditionsLinkStyles), { withTheme: true }),
  withMobileDialog({ breakpoint: `xs` }),
)(TermsAndConditionsLinkComponent);

export default TermsAndConditionsLink;
